import { render, staticRenderFns } from "./LookMsg.vue?vue&type=template&id=2cf409cf&scoped=true&"
import script from "./LookMsg.vue?vue&type=script&lang=js&"
export * from "./LookMsg.vue?vue&type=script&lang=js&"
import style0 from "./LookMsg.vue?vue&type=style&index=0&id=2cf409cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf409cf",
  null
  
)

export default component.exports